import BaseException from '../base_exception'
import InvalidRejectReason from '../file_with_context_result/invalid_reject_reason'

class ServerUpload extends BaseException {
  constructor(fileWithContext) {
    super(InvalidRejectReason.REJECT_REASON.SERVER_ERROR, {
      fileWithContext,
    })
  }
}

export default ServerUpload
